// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_AOv","cls2":"SimplePaperPodcast-cls2_Hec SimplePaperPodcast-cls1_AOv"};